import React from 'react';
import { AuthProvider, useAuth } from './components/AuthContext';
import { ConfigProvider } from './utils/ConfigContext';
import { ThemeProvider } from './components/ThemeContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './App.css';
import './responsive.css';

function AppContent() {
  const { user, loading } = useAuth();

  // Show loading spinner while checking authentication state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <svg className="animate-spin h-12 w-12 text-emerald-600 mx-auto mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return user ? <Dashboard /> : <Login />;
}

function App() {
  return (
    <ConfigProvider>
      <AuthProvider>
        <ThemeProvider>
          <div className="App">
            <AppContent />
          </div>
        </ThemeProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
